export default __webpack_public_path__ + "static/media/hero-bg-d.04d5a569.jpg";